export const CANNOT_COMPLETE_ABANDONED_PLAN = "Cannot complete management plan with an abandon date"
export const CANNOT_ABANDON_COMPLETED_PLAN = "Cannot abandon management plan with a complete date"
